import React from 'react';

export function formatNumberWithSpaces(value: number, options?: Intl.NumberFormatOptions) {
	return value.toLocaleString('en', options).replace(/,/g, ' ');
}

export type RenderNumberOptions = {
	decimalsNumber?: number;
	showValuesInThousands?: boolean;
};

export function renderNumber(value: unknown, options: RenderNumberOptions = {}) {
	if (typeof value != 'number') {
		return value ?? '';
	}

	const decimalsNumber = options.decimalsNumber ?? 0;
	const decimals = { minimumFractionDigits: decimalsNumber, maximumFractionDigits: decimalsNumber };
	if (!options.showValuesInThousands) {
		return formatNumberWithSpaces(value, decimals);
	}

	return (
		<span title={formatNumberWithSpaces(value, { maximumFractionDigits: 20 })}>
			{formatNumberWithSpaces(value / 1000, decimals)}k
		</span>
	);
}
